var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDenmarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M16,5.675C9.819,8.378,5.288,14.113,4.249,21H16V5.675z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M22,43.899C22.658,43.964,23.325,44,24,44c10.023,0,18.3-7.381,19.751-17H22V43.899z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M4.249,27C5.288,33.887,9.819,39.622,16,42.325V27H4.249z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M24,4c-0.675,0-1.342,0.036-2,0.101V21h21.751C42.3,11.381,34.023,4,24,4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M22,4.101c-2.116,0.21-4.13,0.757-6,1.574V21H4.249C4.101,21.981,4,22.978,4,24s0.101,2.019,0.249,3 H16v15.325c1.87,0.818,3.884,1.364,6,1.574V27h21.751C43.899,26.019,44,25.022,44,24s-0.101-2.019-0.249-3H22V4.101z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenmarkIcon);
export default __webpack_public_path__ + "static/media/denmark-icon.c6c612814282fec4e0ddd2110cd702a3.svg";
export { ForwardRef as ReactComponent };